export const NAME_REDUCER = 'giftCardPaid';

export const PREFIX_ACTIONS = 'giftCardPaid_feature_';

export const PATH_LOADING = {
  getGiftCardDetail: `loading.${NAME_REDUCER}.getGiftCardDetail`,
};
